
export default {
  name: 'NewSkeletonBox',
  props: {
    type: {
      type: String,
      default: 'image',
      validator (value) {
        return ['image', 'text', 'button', 'avatar', 'badge'].includes(value)
      }
    },
    shape: {
      type: String,
      default: null,
      validator (value) {
        return value === null || ['square', 'rounded', 'pill', 'circle'].includes(value)
      }
    },
    height: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    padding: {
      type: String,
      default: null
    }
  },
  computed: {
    typeShapeMap () {
      return {
        image: 'square',
        text: 'square',
        button: 'rounded',
        avatar: 'circle',
        badge: 'rounded'
      }
    },
    resolvedShape () {
      return this.shape || this.typeShapeMap[this.type]
    },
    computedHeight () {
      return this.size || this.height
    },
    computedWidth () {
      return this.size || this.width
    },
    skeletonStyle () {
      return {
        width: this.computedWidth,
        height: this.computedHeight,
        padding: this.padding
      }
    }
  }
}
